module.exports = __webpack_public_path__ + "img/pie-chart.396a70e9.png";